export default __webpack_public_path__ + "static/media/close-modal.62e5f1a5.png";